<template>
    <fieldset>
        <div class="order-header">
            <i class="ion-home"></i>
            <h2>Wybierz adres realizacji</h2>
        </div>
        <div class="formFieldWrap">
            <label class="field-title orderStartPoint order-header-label" for="orderStartPoint"><i class=""></i>
            </label>
            <input type="text" autocomplete="street-address" name="Ulica" v-on:keyup="geocodeAddress" onfocus="(this.value == 'Ulica') && (this.value = '')" onblur="(this.value == '') && (this.value = 'Ulica')"  v-bind:class="{ 'error-field': showFieldsError.Street == true }" v-model="address.Street"  class="contactField" id="Name" required  /><span visible-when-invalid="valueMissing" validation-for="name5"></span>
            <input type="text" v-on:keyup="geocodeAddress" onfocus="(this.value == 'Nr budynku') && (this.value = '')" onblur="(this.value == '') && (this.value = 'Nr budynku')" v-bind:class="{ 'error-field': showFieldsError.StreetNo == true }" v-model="address.StreetNo" name="Nr budynku" class="contactField order-field-name" id="Number" required  />
            <input type="text" v-bind:class="{ 'error-field': fieldsError.ApartmentNo == true }" placeholder="Nr lokalu" v-model="address.ApartmentNo" name="Nr lokalu" class="contactField order-field-name" id="Number" required  />
        </div>
        <div class="formFieldWrap">
            <label class="field-title orderStartPoint order-header-label" for="orderStartPoint"><i class=""></i>
            </label>
            <input type="text" v-on:keyup="geocodeAddress" onfocus="(this.value == 'Miejscowość') && (this.value = '')" onblur="(this.value == '') && (this.value = 'Miejscowość')"  v-bind:class="{ 'error-field': showFieldsError.City == true }" v-model="address.City" name="Miejscowosc"  class="contactField" id="Name" required  /><span visible-when-invalid="valueMissing" validation-for="name5"></span>
            <input type="text" autocomplete="postal-code" v-on:keyup="geocodeAddress" v-bind:class="{ 'error-field': showFieldsError.PostalCode == true }" v-model="address.PostalCode" maxlength="6" onfocus="(this.value == 'Kod pocztowy') && (this.value = '')" onblur="(this.value == '') && (this.value = 'Kod pocztowy')" name="Kod-pocztowy"  class="contactField order-field-name" id="Number" required  />
            <input type="text" v-bind:class="{ 'error-field': showFieldsError.FloorNo == true }" onfocus="(this.value == 'Piętro') && (this.value = '')" onblur="(this.value == '') && (this.value = 'Piętro')" v-model="address.FloorNo" name="Pietro"  class="contactField order-field-name" id="Number"  />
        </div>
        <div class="order-info-block" v-show="showAddressError">
            <p class="error-message">Prosimy o uzupełnienie wszystkich niezbędnych pól.</p>
            <p class="error-message" v-show="showFieldsError.PostalCode">Prosimy o wpisanie poprawnego kodu pocztowego według formatu "00-000".</p>
        </div>

    </fieldset>
</template>
<script>
    export default {
        name: 'deliveryAddressSection',
        props: ['address', 'warehouse', 'step', 'zone'],
        data () {
            return {
                addressError: false,
                isGeocoding: false,
                showAddressError: false,
                showFieldsError: {
                    PostalCode: false,
                    Street: false,
                    StreetNo: false,
                    City: false
                },
                fieldsError: {
                    PostalCode: false,
                    Street: false,
                    StreetNo: false,
                    FloorNo: false,
                    City: false,
                    ApartmentNo: false
                },
                defValues: {
                    PostalCode: "Kod pocztowy",
                    Street: "Ulica",
                    StreetNo: "Nr budynku",
                    FloorNo: "Piętro",
                    City: "Miejscowość",
                    ApartmentNo: null
                },
                urls: {
                    getDeliveryData: '/api/delivery/getDeliveryData/'
                }
            }
        },
        methods: {

            geocodeAddress: function() {
                var self = this;
                console.log('geocodeAddress - keup');


                if (document.activeElement.name === 'Kod-pocztowy' && this.validateAddress() && this.isGeocoding === false) {
                    console.log('START GEPOCONDING');
                    self.isGeocoding = true;
                } else {
                    return;
                }

                this.showAddressError = false;

                var params = {
                    Origin: {
                        DivisionID: self.warehouse.ID
                    },
                    Target: {
                        Street: self.address.Street,
                        StreetNo: self.address.StreetNo,
                        City: self.address.City,
                        PostalCode: self.address.PostalCode
                    }
                };
                self.$http.post(self.urls.getDeliveryData, {delivParams: params}).then(function (response) {
                    // @TODO - dodac emit z informacja o km i koszcie?
                    console.log(response);
                    console.log('/////////////////////////////////////////////////////////////////');
                    if (response.data.status == 'cant_geocode') {
                        alert('Nie można ustalić adresu');
                        self.$emit('setOrderStep', 2);
                    }
                    if (response.data.distance) {
                        self.$emit('setDelivDistance', parseFloat(response.data.distance));
                    }
                    if (response.data.customerLocation) {
                        self.$emit('setCustomerLocation', response.data.customerLocation);
                        self.$store.commit('setDeliveryLocation', {Lat: response.data.customerLocation.Lat, Lng: response.data.customerLocation.Lng})
                    }
                    if (response.data.zone) {
                        self.zone.ID = response.data.zone.ID;
                        self.zone.Symbol = response.data.zone.Symbol;
                    }
                    self.isGeocoding = false;
                });
            },

            validateAddress: function () {
                var validAddress = true;

                this.showAddressError = false;
                this.showFieldsError.PostalCode = false;
                this.showFieldsError.Street = false;
                this.showFieldsError.StreetNo = false;
                this.showFieldsError.City = false;

                this.fieldsError.PostalCode = false;
                this.fieldsError.Street = false;
                this.fieldsError.StreetNo = false;
                this.fieldsError.FloorNo = false;
                this.fieldsError.City = false;
                this.fieldsError.ApartmentNo = false;

                if (_.isEmpty(_.trim(this.address.City)) || this.address.City == this.defValues.City) {
                    this.fieldsError.City = true;
                    validAddress = false;
                }
                if (_.isEmpty(_.trim(this.address.Street)) || this.address.Street == this.defValues.Street) {
                    this.fieldsError.Street = true;
                    validAddress = false;
                }
                if (_.isEmpty(_.trim(this.address.StreetNo)) || this.address.StreetNo == this.defValues.StreetNo) {
                    this.fieldsError.StreetNo = true;
                    validAddress = false;
                }
                if (_.isEmpty(_.trim(this.address.PostalCode)) || !this.isValidPostalCode(this.address.PostalCode) || this.address.PostalCode == this.defValues.PostalCode) {
                    console.log(this.address.PostalCode);
                    this.fieldsError.PostalCode = true;
                    validAddress = false;
                }

                this.addressError = !validAddress;

                return validAddress;
            },
            isValidPostalCode: function (postalCode) {
                return /^\d{2}(-\d{3})$/.test(postalCode);
            }
        },
        created: function() {
            console.log("DASection - mounted");
            var self = this

            Event.$on('orderStep', function(step) {

                if (step == 3) {
                    console.log("DA - validateAddress");
                    self.validateAddress();
                    if (self.addressError == false) {
                        console.log("Adres poprawny");
                    } else {
                        self.showAddressError = true;
                        self.showFieldsError.PostalCode = (self.fieldsError.PostalCode === true) ? true : false;
                        self.showFieldsError.Street = (self.fieldsError.Street) ? true : false;
                        self.showFieldsError.StreetNo = (self.fieldsError.StreetNo) ? true : false;
                        self.showFieldsError.City = (self.fieldsError.City) ? true : false;
                    }
                    self.$emit("setAddressError", self.addressError);
                }

            });

            this.address.Street = this.defValues.Street;
            this.address.StreetNo = this.defValues.StreetNo;
            this.address.ApartmentNo = this.defValues.ApartmentNo;
            this.address.City = this.defValues.City;
            this.address.PostalCode = this.defValues.PostalCode;
            this.address.FloorNo = this.defValues.FloorNo;

            if (this.$store.state.testMode) {
                console.log('STORE--------------')
                this.address.PostalCode = this.$store.state.deliveryAddress.PostalCode
                this.address.Street = this.$store.state.deliveryAddress.Street
                this.address.StreetNo = this.$store.state.deliveryAddress.StreetNo
                //this.address.FloorNo = "";
                this.address.City = this.$store.state.deliveryAddress.City
                //this.address.ApartmentNo = ""
            }

        }
    }
</script>
<style>
    .error-field{
        border:1px solid #F44336 !important;
    }
</style>



// WEBPACK FOOTER //
// DeliveryAddressSection.vue?bb3cedb4